import React from "react";
import { MODE } from "../../../constants/common";
import AddEditCatalog from "./AddEditCatalog/AddEditCatalog";
import CatalogList from "./CatalogList/CatalogList";
import PropTypes from "prop-types";

function Catalog(props) {
  const {
    id,
    distributorId,
    catalogId,
    mode,
    onSave,
    onCancel,
    onEdit,
    onNext,
    query,
    onView,
    showColumnPopup,
    onQueryChange,
    anchorEl,
    setAnchorEl,
    signUpApproval,
    permissions,
    setContentId,
    setContentMode,
  } = props;

  return (
    <div>
      {mode === MODE.LIST ? (
        <CatalogList
          id={id}
          query={query}
          showColumnPopup={showColumnPopup}
          onCancelTableColumnSelection={props.onCancelTableColumnSelection}
          onView={onView}
          onEdit={onEdit}
          setQuery={onQueryChange}
          setAnchorEl={setAnchorEl}
          signUpApproval={signUpApproval}
          permissions={permissions}
        />
      ) : (
        <AddEditCatalog
          id={id}
          anchorEl={anchorEl}
          query={query}
          distributorId={distributorId}
          catalogId={catalogId}
          setQuery={onQueryChange}
          setSelectedSubTab={props.setSelectedSubTab}
          mode={mode}
          onEdit={onEdit}
          onSave={onSave}
          onView={onView}
          onCancel={onCancel}
          onNext={onNext}
          showColumnPopup={showColumnPopup}
          onCancelTableColumnSelection={props.onCancelTableColumnSelection}
          onSaveTableColumnSelection={props.onSaveTableColumnSelection}
          setSelectionColumns={props.setSelectionColumns}
          setAnchorEl={setAnchorEl}
          signUpApproval={signUpApproval}
          permissions={permissions}
          setContentId={setContentId}
          setContentMode={setContentMode}
          routeData={props.routeData}
        />
      )}
    </div>
  );
}

Catalog.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  distributorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  catalogId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  onEdit: PropTypes.func,
  onNext: PropTypes.func,
  query: PropTypes.object,
  onView: PropTypes.func,
  showColumnPopup: PropTypes.bool,
  onQueryChange: PropTypes.func,
  anchorEl: PropTypes.any,
  setAnchorEl: PropTypes.func,
  signUpApproval: PropTypes.shape({
    approvalId: PropTypes.number,
    status: PropTypes.number,
  }),
  permissions: PropTypes.arrayOf(PropTypes.string),
  setContentId: PropTypes.func,
  setContentMode: PropTypes.func,
  onCancelTableColumnSelection: PropTypes.func,
  onSaveTableColumnSelection: PropTypes.func,
  setSelectionColumns: PropTypes.func,
  setSelectedSubTab: PropTypes.func,
  routeData: PropTypes.shape({
    userTypeId: PropTypes.number,
  }),
};

Catalog.defaultProps = {
  id: 0,
  distributorId: 0,
  catalogId: 0,
  mode: MODE.LIST,
  onSave: () => {},
  onCancel: () => {},
  onEdit: () => {},
  onNext: () => {},
  query: {},
  onView: () => {},
  showColumnPopup: false,
  onQueryChange: () => {},
  anchorEl: null,
  setAnchorEl: () => {},
  signUpApproval: null,
  permissions: [],
  setContentId: () => {},
  setContentMode: () => {},
  onCancelTableColumnSelection: () => {},
  onSaveTableColumnSelection: () => {},
  setSelectionColumns: () => {},
  setSelectedSubTab: () => {},
  routeData: { userTypeId: 0 },
};

export default Catalog;
